import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
	root: {},
	wizardSection: {
		marginTop: theme.spacing(3),
	},
}));
